interface LogoMarkProps {
  className?: string
}

export const LogoMark: React.FC<LogoMarkProps> = ({ className }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 81 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.8494 12.3949C32.0116 15.9084 28.1066 22.3063 28.1066 29.6163C28.1066 36.9266 32.012 43.3247 37.8502 46.8382C35.5908 47.8051 33.1027 48.3404 30.4896 48.3404C20.1488 48.3404 11.7659 39.9575 11.7659 29.6167C11.7659 19.2758 20.1488 10.8929 30.4896 10.8929C33.1024 10.8929 35.5902 11.4281 37.8494 12.3949ZM52.7184 49.1896C61.6314 47.1368 68.2775 39.1527 68.2775 29.6163C68.2775 20.0796 61.631 12.0952 52.7175 10.0427C50.6691 7.7184 48.2619 5.71791 45.5825 4.1279C47.0672 3.87521 48.5947 3.74343 50.1544 3.74343C64.8878 3.74343 76.788 15.5034 76.788 29.9566C76.788 44.4099 64.8878 56.1698 50.1544 56.1698C48.2787 56.1698 46.4495 55.9793 44.6852 55.6169C47.7264 53.953 50.4437 51.771 52.7184 49.1896ZM30.4896 59.2342C33.7284 59.2342 36.8458 58.7143 39.7628 57.7535C43.0032 58.9316 46.5045 59.5742 50.1544 59.5742C66.7198 59.5742 80.1923 46.3378 80.1923 29.9566C80.1923 13.5754 66.7198 0.339112 50.1544 0.339112C46.8701 0.339112 43.7059 0.859434 40.7436 1.82224C37.5485 0.643099 34.0943 -0.000854492 30.4896 -0.000854492C14.1323 -0.000854492 0.87207 13.2594 0.87207 29.6167C0.87207 45.974 14.1323 59.2342 30.4896 59.2342Z"
      fill="currentColor"
    />
  </svg>
)
